import * as React from 'react';

const SvgActionZapDetails = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M20 8V6.59L15.41 2H4v20h16V10h-2v10H6V4h8v4h6Z" }),
  React.createElement("path", { fill: "#2D2E2E", d: "m10.75 18.858 4.809-5.729H13.25V9.067l-4.808 5.729h2.308v4.062Z" })
);

export { SvgActionZapDetails as default };
//# sourceMappingURL=ActionZapDetails.es.js.map
